"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPtimizacion = void 0;
class OPtimizacion {
    constructor() {
        this.tipo = "";
        this.regla = "";
        this.antes = "";
        this.despues = "";
        this.linea = "";
    }
}
exports.OPtimizacion = OPtimizacion;
